import type { RouteRecordRaw } from 'vue-router'

const organizationsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/organizations',
    name: 'organizations.index',
    component: () => import('@/modules/user/organization/views/OrganizationsIndex.vue'),
    meta: {
      pageTitle: 'Organizations',
      breadcrumbs: ['Settings', 'Organizations']
    }
  },
  {
    path: '/settings/organizations/:id',
    name: 'organizations.show',
    component: () => import('@/modules/user/organization/views/OrganizationsShow.vue'),
    meta: {
      pageTitle: 'Organization',
      breadcrumbs: ['Settings', 'Organizations']
    }
  }
]

export default organizationsRoutes
